import React from 'react';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import CancelOffersListItemComponent from './CancelOffersListItemComponent';
import ViewList from '@mui/icons-material/ViewList';

const CancelOffersListComponent = ({
  documentTypes,
  conditions,
  reasons,
  referenceDates,
  handleAdd,
  onDelete,
  onLookupPropertyChanged,
  onPropertyChanged,
  validation
}) => {
  const { t } = useTranslation();

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('CancelOffers.Conditions')}
      actions={<IconButton type='add' size='small' color='primary' variant='text' tooltip={t('Tooltips.Add')} onClick={handleAdd} />}
    >
      <Grid container spacing={2}>
        {conditions?.map((item, idx) => {
          return (
            <Grid key={idx} item xs={12}>
              <CancelOffersListItemComponent
                key={idx}
                item={item}
                index={idx}
                documentTypes={documentTypes}
                referenceDates={referenceDates}
                reasons={reasons}
                onDelete={onDelete}
                onPropertyChanged={onPropertyChanged}
                onLookupPropertyChanged={onLookupPropertyChanged}
                validation={validation}
              />
            </Grid>
          );
        })}
      </Grid>
    </Card>
  );
};

CancelOffersListComponent.propTypes = {
  documentTypes: PropTypes.array.isRequired,
  conditions: PropTypes.array,
  reasons: PropTypes.array,
  referenceDates: PropTypes.array.isRequired,
  handleAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onLookupPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default CancelOffersListComponent;
